import { LotteryActivityInfoList } from "../hooks/useFetchLotteryActivityInfoList";
import { BindActivityInfo } from "@/components/top-up/types";
import { dateFormater } from "project-config/utils/format-time";
import {
  CashPrizeText,
  TicketReceivingInfoType,
  PrizeLevelContent,
} from "../constants";

function isEndCashPrize(endTime?: number) {
  const nowDate = new Date().getTime();
  if (!endTime) return;
  return nowDate >= endTime;
}

export function getCashPrizeStatus(
  showCashActivityEntry: boolean,
  data?: LotteryActivityInfoList
) {
  let content = CashPrizeText[TicketReceivingInfoType.Recharge];
  if (showCashActivityEntry && data) {
    const { endTime, remark, receivingInfo } = data;
    content = CashPrizeText[TicketReceivingInfoType.Edit];
    if (!receivingInfo) {
      content = CashPrizeText[TicketReceivingInfoType.NoFillin];
    }
    if (isEndCashPrize(endTime) && receivingInfo && !remark) {
      // 已过兑奖时间但还无物流状态
      content = CashPrizeText[TicketReceivingInfoType.Cash];
      content.subTitle = "topup_lottery_await_information_update";
    }
    if (isEndCashPrize(endTime) && !receivingInfo) {
      content = CashPrizeText[TicketReceivingInfoType.Expired];
    }
    if (remark) {
      content = CashPrizeText[TicketReceivingInfoType.Cash];
    }
  }
  return content;
}

export function getCashPrizeTime(
  fields: string,
  data?: BindActivityInfo | LotteryActivityInfoList
) {
  if (!data) return "";
  return dateFormater(Number(data[fields])).replaceAll("-", ".");
}

export function getCashPrizeSubContent(
  fields: string,
  isDateType?: boolean,
  data?: LotteryActivityInfoList
) {
  if (!data) return "";
  if (isDateType)
    return dateFormater(Number(data[fields])).replaceAll("-", ".");
  return data[fields];
}

export function getCashPrizeType(
  type: number | string,
  isZh: boolean,
  data?: LotteryActivityInfoList[]
) {
  if (type === "" || !type) return type;
  const tempData: string[] = [];
  if (data) {
    data
      .map((p) => p.prizeType)
      .sort()
      .map((item) => {
        const result = PrizeLevelContent[Number(item)];
        if (!result) return "";
        const { cnName, enName } = result;
        return tempData.push(isZh ? cnName : enName);
      });
    return Array.from(new Set(tempData)).join("，");
  }
  const result = PrizeLevelContent[Number(type)];
  if (!result) return "";
  const { cnName, enName } = result;
  return isZh ? cnName : enName;
}
